import script from "./PaginationCom.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationCom.vue?vue&type=script&setup=true&lang=js"

import "./PaginationCom.vue?vue&type=style&index=0&id=1529152e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1529152e"]])

export default __exports__